<template>
    <div id="X15">
        <view1 :selectedProduct="selectedProduct" />
        <Tabs :activeTab.sync="activeTab" :tabs="flightPlatform" />
        <view2 :selectedProduct="selectedProduct" />
        <view4 :selectedProduct="selectedProduct" />
        <view3 :selectedProduct="selectedProduct" v-if="activeTab === 'LANYVE-X15'" />
        <otherView3 :selectedProduct="selectedProduct" v-else />
        <view5 :selectedProduct="selectedProduct" v-if="activeTab === 'LANYVE-X15'" />
        <features :selectedProduct="selectedProduct" v-if="activeTab !== 'LANYVE-X15'" />
        <scene :selectedProduct="selectedProduct" v-if="activeTab !== 'LANYVE-X15'" />
    </div>
</template>
<script>
import productData from '@/mixins/productData.js'
export default {
    name: 'aboutlanyve',
    mixins: [productData],
    components: {
        view1: () => import('@/views/X15/view1.vue'),
        view2: () => import('@/views/X15/view2.vue'),
        view3: () => import('@/views/X15/view3.vue'),
        view4: () => import('@/views/X15/view4.vue'),
        view5: () => import('@/views/X15/view5.vue'),
        otherView3: () => import('@/views/X15/otherView3.vue'),
        features: () => import('@/views/X15/features.vue'),
        scene: () => import('@/views/X15/scene.vue'),
        Tabs: () => import('@/components/tabs.vue')
    },
    data() {
        return {
            activeTab: '',
            selectedProduct: null,
        }
    },
    watch: {
        '$route.query.code': {
            handler(newVal) {
                const code = newVal || 'LANYVE-X15';
                this.activeTab = code;
            },
            immediate: true
        },
        activeTab: {
            handler(newVal) {
                const targetRoute = `/x15?code=${newVal}`;
                const currentRoute = this.$route.fullPath;
                if (currentRoute !== targetRoute) {
                    this.$router.push(targetRoute).catch(err => {
                        if (err.name !== 'NavigationDuplicated') {
                            console.error(err);
                        }
                    });
                }
                this.selectedProduct = this.flightPlatform.find(item => item.code === newVal) || this.flightPlatform[0];
            },
            immediate: true
        }
    },

}
</script>
<style scoped>

</style>